import { render, staticRenderFns } from "./EventTypeNew.vue?vue&type=template&id=76dffdda"
import script from "./EventTypeNew.vue?vue&type=script&lang=js"
export * from "./EventTypeNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports